import { Paper, Link, Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import DescriptionList from 'components/DescriptionList'
import AdminEmploymentDetailContext from 'pages/AdminEmploymentDetail/context'
import React from 'react'
import { adminJobDetailURL, adminNurseDetailURL, adminPracticeDetailURL } from 'routes/urls'

const AdminEmploymentInfo: React.FC = () => {
  const { employment } = React.useContext(AdminEmploymentDetailContext)

  const nurseCard = React.useMemo(() => {
    return (
      <Paper sx={{ padding: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <DescriptionList labelWidth='40%' valueWidth='60%' rowGap={1} data={[{
          label: 'Nurse Name',
          value: (
            <Link component={RouterLink} to={adminNurseDetailURL(employment.nurse_id)}>
              { employment.nurse_name }
            </Link>
          ),
        }, {
          label: 'Nurse Email',
          value: employment.nurse_email,
        }, {
          label: 'Nurse Phone',
          value: employment.nurse_phone_number,
        }, {
          label: 'Nurse GDC Number',
          value: employment.nurse_gdc_number,
        }]} />
      </Paper>
    )
  }, [employment])

  const practiceCard = React.useMemo(() => {
    return (
      <Paper sx={{ padding: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <DescriptionList labelWidth='40%' valueWidth='60%' rowGap={1} data={[{
          label: 'Practice Name',
          value: (
            <Link component={RouterLink} to={adminPracticeDetailURL(employment.practice_id)}>
              { employment.practice_name }
            </Link>
          ),
        }, {
          label: 'Practice Phone',
          value: employment.practice_phone_number,
        }, {
          label: 'Practice Address',
          value: employment.practice_address,
          sx: { whiteSpace: 'pre-line' }
        }]} />
      </Paper>
    )
  }, [employment])

  const jobCard = React.useMemo(() => {
    return (
      <Paper sx={{ padding: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <DescriptionList labelWidth='40%' valueWidth='60%' rowGap={1} data={[{
          label: 'Job ID',
          value: (
            <Link component={RouterLink} to={adminJobDetailURL(employment.job_id)}>
              { employment.job_id }
            </Link>
          ),
        }, {
          label: 'Job Posted At',
          value: employment.posted_at_label(employment.practice_tz),
        }, {
          label: 'Job Taken At',
          value: employment.taken_at_label(employment.practice_tz),
        }, {
          label: 'Bonus To Good Tier At',
          value: employment.bonus_to_good_tier_at_label(employment.practice_tz),
        }, {
          label: 'Bonus To New Tier At',
          value: employment.bonus_to_new_tier_at_label(employment.practice_tz),
        }, {
          label: 'Bonus To Bad Tier At',
          value: employment.bonus_to_bad_tier_at_label(employment.practice_tz),
        }, {
          label: 'Nurse Tier When Job Is Taken',
          value: employment.nurse_tier_when_job_is_taken,
        }, {
          label: 'Job Description',
          value: employment.description,
        }, {
          label: 'Parking',
          value: employment.parking_label
        }, {
          label: 'Is Bonus Job',
          value: employment.is_bonus_job ? 'Yes' : 'No',
        }, {
          label: 'Job Role',
          value: employment.job_role,
        }, {
          label: 'Sedation Required',
          value: employment.sedation_required ? 'Yes' : 'No',
        }, {
          label: 'Radiography Required',
          value: employment.radiography_required ? 'Yes' : 'No',
        }, {
          label: 'Implant Required',
          value: employment.implant_required ? 'Yes' : 'No',
        }, {
          label: 'Orthodontics Required',
          value: employment.orthodontics_required ? 'Yes' : 'No',
        }]} />
      </Paper>
    )
  }, [employment])
  
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      { nurseCard }
      { practiceCard }
      { jobCard }
    </Box>
  )
}

export default AdminEmploymentInfo